import { StorageCreationNotAllowed, ContextCreationNotAllowed } from '../../contextErrors';
import { BaseContextManager } from '../BaseContextManager';

/**
 * Immutable context manager.
 * Based on BaseContextManager. Including run and with implementation that throw exceptions when executed.
 */
export abstract class ImmutableContextManager extends BaseContextManager {
    /**
     * Blocks creating new root storage, throws once called.
     *
     * @param _exposeTo - function the context will be exposed to.
     */
    run<T>(_exposeTo: (...args: any[]) => T): T {
        throw new StorageCreationNotAllowed(this.runtimeName);
    }

    /**
     * Blocks creating new context, throws once called.
     *
     * @param contextName context name to set
     * @param _context context value to expose under the given name.
     */
    override with(contextName: string, _context: unknown) {
        throw new ContextCreationNotAllowed(contextName, this.runtimeName);
    }
}
